webpackJsonp([135],{

/***/ 1007:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditInternDetail_vue__ = __webpack_require__(2522);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7094c421_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditInternDetail_vue__ = __webpack_require__(3221);
function injectStyle (ssrContext) {
  __webpack_require__(3211)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7094c421"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditInternDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7094c421_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditInternDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = trimParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeEmptyParams;
/* unused harmony export setParams */
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* unused harmony export conveSomeDataType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSearchParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query, to.params);
        // 设置搜索参数。 当仅 params 更新时, 需要全部重置 search 数据
        vm.setSearchParams(_.merge(vm.$options.data.call(vm).search, queryParams));
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query, to.params);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     * @param {*} params
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.params;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      if (params.hasOwnProperty('')) {
        delete params[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, params), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSearchParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSearchParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      if (params[key] && params[key].constructor === Object) {
        setParams(params[key], newParams[key]);
      } else {
        Vue.set(params, key, newParams[key]);
      }
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(22);


/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(12);
var LIBRARY = __webpack_require__(104);
var wksExt = __webpack_require__(1350);
var defineProperty = __webpack_require__(54).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(144)('meta');
var isObject = __webpack_require__(55);
var has = __webpack_require__(75);
var setDesc = __webpack_require__(54).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(76)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(244);
var hiddenKeys = __webpack_require__(148).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(78);

/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(79);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(77);

/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1365);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1366);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1368), __esModule: true };

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1369), __esModule: true };

/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(235);
var createDesc = __webpack_require__(103);
var toIObject = __webpack_require__(100);
var toPrimitive = __webpack_require__(236);
var has = __webpack_require__(75);
var IE8_DOM_DEFINE = __webpack_require__(243);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(40) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143);
__webpack_require__(234);
module.exports = __webpack_require__(1350).f('iterator');


/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1370);
__webpack_require__(241);
__webpack_require__(1373);
__webpack_require__(1374);
module.exports = __webpack_require__(12).Symbol;


/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(17);
var has = __webpack_require__(75);
var DESCRIPTORS = __webpack_require__(40);
var $export = __webpack_require__(28);
var redefine = __webpack_require__(245);
var META = __webpack_require__(1353).KEY;
var $fails = __webpack_require__(76);
var shared = __webpack_require__(147);
var setToStringTag = __webpack_require__(105);
var uid = __webpack_require__(144);
var wks = __webpack_require__(22);
var wksExt = __webpack_require__(1350);
var wksDefine = __webpack_require__(1351);
var enumKeys = __webpack_require__(1371);
var isArray = __webpack_require__(1356);
var anObject = __webpack_require__(41);
var isObject = __webpack_require__(55);
var toObject = __webpack_require__(78);
var toIObject = __webpack_require__(100);
var toPrimitive = __webpack_require__(236);
var createDesc = __webpack_require__(103);
var _create = __webpack_require__(240);
var gOPNExt = __webpack_require__(1372);
var $GOPD = __webpack_require__(1367);
var $GOPS = __webpack_require__(237);
var $DP = __webpack_require__(54);
var $keys = __webpack_require__(101);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(1354).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(235).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(104)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(56)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(101);
var gOPS = __webpack_require__(237);
var pIE = __webpack_require__(235);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(100);
var gOPN = __webpack_require__(1354).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1351)('asyncIterator');


/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1351)('observable');


/***/ }),

/***/ 1865:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auditInternPermissionMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var baseExportHeader = [{ key: 'id', text: '账号ID' }, { key: 'name', text: '账号' }, { key: 'realname', text: '姓名' }, { key: 'employment_type', text: '人员性质' }, { key: 'office_location', text: '办公地点' }, { key: 'status', text: '状态' }, { key: 'phone', text: '手机号' }, { key: 'mail_address', text: '个人邮箱' }, { key: 'school', text: '目前所在院校' }, { key: 'major', text: '专业' }, { key: 'education_level', text: '学历' }, { key: 'grade_level', text: '当前学年段' }, { key: 'student_card_photos', text: '学生证照片' }, { key: 'contract_start_date', text: '合同开始时间' }, { key: 'contract_end_date', text: '合同结束时间' }, { key: 'remark', text: '备注' }, { key: 'participant_customers', text: '累计参与客户(系统自动维护,不可修改)' }, { key: 'participant_projects', text: '累计参与项目(系统自动维护,不可修改)' }];

// 权限控制方法
var auditInternPermissionMixin = {
  methods: {
    /**
     * 判断是否允许查看实习生列表
     * @returns {boolean}
     */
    allowViewInternTable: function allowViewInternTable() {
      return filter.hasPermission(40001);
    },

    /**
     * 判断是否允许编辑/查看基础资料
     * @returns {boolean}
     */
    allowViewEditBase: function allowViewEditBase() {
      return filter.hasPermission(40002);
    },

    /**
     * 判断是否允许编辑/查看隐私信息
     * @returns {boolean}
     */
    allowViewEditPrivate: function allowViewEditPrivate() {
      return filter.hasPermission(40003);
    },

    /**
     * 判断是否允许编辑/查看资源控制信息
     * @returns {boolean}
     */
    allowViewEditResource: function allowViewEditResource() {
      return filter.hasPermission(40004);
    },

    /**
     * 判断是否允许编辑/查看分配用户资源
     * @returns {boolean}
     */
    allowViewEditUserResource: function allowViewEditUserResource() {
      return filter.hasPermission(40005);
    },

    /**
     * 判断是否允许添加实习生账号
     * @returns {boolean}
     */
    allowCreateIntern: function allowCreateIntern() {
      return filter.hasPermission(40006);
    },

    /**
     * 判断是否允许导出实习生隐私信息
     * @returns {boolean}
     */
    allowExportPrivateData: function allowExportPrivateData() {
      return filter.hasPermission(40007);
    }
  },
  computed: {
    /**
     * 根据权限自动选择默认标签页
     * @returns {string}
     */
    getActiveTab: function getActiveTab() {
      if (this.allowViewEditBase()) {
        return 'baseInfo';
      } else if (this.allowViewEditPrivate()) {
        return 'privateInfo';
      } else if (this.allowViewEditResource()) {
        return 'resourceInfo';
      } else if (this.allowViewEditUserResource()) {
        return 'userResourceInfo';
      } else {
        return '';
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    var _this = this;

    return {
      tableColumns: [{ prop: 'id', label: '账号ID', minWidth: '90' }, { prop: 'realname', label: '姓名', minWidth: '100' }, { prop: 'name', label: '账号', minWidth: '120' }, { prop: 'phone', label: '手机号', minWidth: '120' }, { prop: 'employment_type', label: '人员性质', minWidth: '80', formatter: function formatter(row) {
          return _.get(_this.employmentTypeMap, row.employment_type, '-');
        } }, { prop: 'participant_customers', label: '累计参与客户', width: '200' }, { prop: 'status', label: '用户状态', minWidth: '100', formatter: function formatter(row) {
          return _.get(_this.statusMap, row.status, '-');
        } }, { prop: 'total_work_days', label: '累计出勤天数', minWidth: '100' }],
      exportBaseHeader: baseExportHeader,
      exportFullHeader: [].concat(baseExportHeader, [{ key: 'assigned_customers', text: '客户资源' }, { key: 'ui_roles', text: 'UI角色' }, { key: 'api_roles', text: 'API角色' }, { key: 'id_number', text: '身份证号' }, { key: 'id_card_front_photo', text: '身份证正面照片' }, { key: 'id_card_back_photo', text: '身份证反面照片' }, { key: 'bank_name', text: '银行名称' }, { key: 'bank_branch_name', text: '支行信息' }, { key: 'bank_card_number', text: '银行卡号' }, { key: 'bank_card_photo', text: '银行卡照片' }])
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    employmentTypeMap: function employmentTypeMap(state) {
      return state.auditIntern.employmentTypeMap;
    },
    educationLevelMap: function educationLevelMap(state) {
      return state.auditIntern.educationLevelMap;
    },
    officeLocationMap: function officeLocationMap(state) {
      return state.auditIntern.officeLocationMap;
    },
    gradeLevelMap: function gradeLevelMap(state) {
      return state.auditIntern.gradeLevelMap;
    },
    statusMap: function statusMap(state) {
      return state.auditIntern.statusMap;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, auditInternPermissionMixin.methods)
});

/***/ }),

/***/ 2522:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_viewerjs_dist_viewer_css__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_viewerjs__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_viewerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_viewerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_InternLogTable_vue__ = __webpack_require__(3213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__audit_intern_mixins_js__ = __webpack_require__(1865);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__audit_intern_mixins_js__["a" /* auditInternPermissionMixin */]],
  components: { InternLogTable: __WEBPACK_IMPORTED_MODULE_4__components_InternLogTable_vue__["a" /* default */] },
  data: function data() {
    return {
      id: 0,
      activeTab: 'baseInfo',
      baseInfo: {
        id: '',
        name: '',
        realname: '',
        employment_type: '',
        office_location: null,
        status: '',
        phone: '',
        mail_address: '',
        school: '',
        major: '',
        education_level: '',
        grade_level: '',
        student_card_photos: [],
        participant_projects: [],
        participant_customers: [],
        assigned_customers: [],
        total_work_days: 0,
        contract_start_date: '',
        contract_end_date: '',
        remark: ''
      },
      privateInfo: {
        bank_card_number: '',
        bank_name: '',
        bank_branch_name: '',
        bank_card_photo: [],
        id_number: '',
        id_card_front_photo: '',
        id_card_back_photo: ''
      },
      resourceInfo: {
        assigned_customers: [],
        ui_roles: [],
        api_roles: []
      },
      viewer: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapState"])({
    employmentTypeMap: function employmentTypeMap(state) {
      return state.auditIntern.employmentTypeMap;
    },
    educationLevelMap: function educationLevelMap(state) {
      return state.auditIntern.educationLevelMap;
    },
    officeLocationMap: function officeLocationMap(state) {
      return state.auditIntern.officeLocationMap;
    },
    gradeLevelMap: function gradeLevelMap(state) {
      return state.auditIntern.gradeLevelMap;
    },
    statusMap: function statusMap(state) {
      return state.auditIntern.statusMap;
    }
  }), {
    baseInfoTableData: function baseInfoTableData() {
      return [{ label: '用户ID', value: this.baseInfo.id, type: 'text' }, { label: '账号', value: this.baseInfo.name, type: 'text' }, { label: '姓名', value: this.baseInfo.realname, type: 'text' }, { label: '人员性质', value: this.employmentTypeMap[this.baseInfo.employment_type], type: 'map' }, { label: '办公地点', value: this.officeLocationMap[this.baseInfo.office_location], type: 'map' }, { label: '用户状态', value: this.statusMap[this.baseInfo.status], type: 'map' }, { label: '手机号', value: this.baseInfo.phone, type: 'text' }, { label: '个人邮箱', value: this.baseInfo.mail_address, type: 'text' }, { label: '目前所在院校', value: this.baseInfo.school, type: 'text' }, { label: '专业', value: this.baseInfo.major, type: 'text' }, { label: '学历', value: this.educationLevelMap[this.baseInfo.education_level], type: 'map' }, { label: '当前学年段', value: this.gradeLevelMap[this.baseInfo.grade_level], type: 'map' }, { label: '学生证照片', value: this.baseInfo.student_card_photos, type: 'images' }, {
        label: '合同时间',
        value: this.baseInfo.contract_start_date ? this.baseInfo.contract_start_date + ' ~ ' + this.baseInfo.contract_end_date : '',
        type: 'dateRange'
      }, { label: '备注', value: this.baseInfo.remark, type: 'text' }, { label: '累计工作天数', value: this.baseInfo.total_work_days + '\u5929', type: 'text' }, {
        label: '累计参与客户',
        value: this.baseInfo.participant_customers.map(function (item) {
          return item.name + '/' + item.id;
        }),
        type: 'tags'
      }, {
        label: '累计参与项目',
        value: this.baseInfo.participant_projects.map(function (item) {
          return item.name + '/' + item.id;
        }),
        type: 'tags'
      }];
    },
    privateInfoTableData: function privateInfoTableData() {
      var idCardPhotos = [this.privateInfo.id_card_front_photo, this.privateInfo.id_card_back_photo].filter(Boolean);
      return [{ label: '银行卡号', value: this.privateInfo.bank_card_number, type: 'text' }, { label: '银行信息', value: this.privateInfo.bank_name, type: 'text' }, { label: '开户城市', value: this.privateInfo.bank_branch_name, type: 'text' }, { label: '银行卡照片', value: this.privateInfo.bank_card_photo, type: 'images' }, { label: '身份证号', value: this.privateInfo.id_number, type: 'text' }, { label: '身份证照片', value: idCardPhotos, type: 'idCardImages' }];
    },
    resourceInfoTableData: function resourceInfoTableData() {
      var formatResourceTags = function formatResourceTags(items) {
        if (!Array.isArray(items)) return [];
        return items.map(function (item) {
          if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object' && item !== null) {
            return item.name + '/' + item.id;
          }
          return item;
        });
      };

      return [{ label: '客户资源', value: formatResourceTags(this.resourceInfo.assigned_customers), type: 'tags' }, { label: 'UI权限角色', value: formatResourceTags(this.resourceInfo.ui_roles), type: 'tags' }, { label: 'API权限角色', value: formatResourceTags(this.resourceInfo.api_roles), type: 'tags' }];
    }
  }),
  beforeRouteEnter: function beforeRouteEnter(_to, _from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(_to, _from, next) {
    this.onLoad();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['getInternBaseInfoApi', 'getInternPrivateInfoApi']), {
    onViewPhotos: function onViewPhotos(containerType, index) {
      var containerId = '';
      switch (containerType) {
        case 'baseInfo':
          containerId = 'baseInfoPhotoContainer';
          break;
        case 'privateInfo':
          containerId = 'privateInfoPhotoContainer';
          break;
        case 'idCardPhotos':
          containerId = 'idCardPhotosContainer';
          break;
      }
      if (this.viewer) {
        this.viewer.destroy();
      }
      this.viewer = new __WEBPACK_IMPORTED_MODULE_3_viewerjs___default.a(document.getElementById(containerId));
      this.viewer.view(index);
    },
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.id = this.$route.params.id;
        // 根据权限设置默认标签页
        if (this.allowViewEditBase()) {
          this.activeTab = 'baseInfo';
        } else if (this.allowViewEditPrivate()) {
          this.activeTab = 'privateInfo';
        } else if (this.allowViewEditResource()) {
          this.activeTab = 'resourceInfo';
        } else {
          this.activeTab = 'logInfo';
        }

        if (this.allowViewEditBase() || this.allowViewEditResource()) {
          this.fetchBaseInfo();
        }
        if (this.allowViewEditPrivate()) {
          this.fetchPrivateInfo();
        }
      }
    },
    fetchBaseInfo: function fetchBaseInfo() {
      var _this = this;

      request.common('getInternBaseInfoApi', { id: this.id }).then(function (_ref) {
        var data = _ref.data;

        if (data) {
          _this.baseInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.baseInfo, data);
          // 同时获取资源控制信息
          if (_this.allowViewEditResource()) {
            _this.resourceInfo.assigned_customers = data.assigned_customers || [];
            _this.resourceInfo.ui_roles = data.ui_roles || [];
            _this.resourceInfo.api_roles = data.api_roles || [];
          }
        }
      }).catch(function (err) {
        _this.$message.error(err.message || '获取基础资料失败');
      });
    },
    fetchPrivateInfo: function fetchPrivateInfo() {
      var _this2 = this;

      request.common('getInternPrivateInfoApi', { id: this.id }).then(function (_ref2) {
        var data = _ref2.data;

        if (data) {
          _this2.privateInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this2.privateInfo, data);
        }
      }).catch(function (err) {
        _this2.$message.error(err.message || '获取隐私信息失败');
      });
    },
    handleTabClick: function handleTabClick(tab) {
      if (!this.id) return;

      var tabName = tab.name;
      if (tabName === 'baseInfo' && this.allowViewEditBase()) {
        this.fetchBaseInfo();
      } else if (tabName === 'privateInfo' && this.allowViewEditPrivate()) {
        this.fetchPrivateInfo();
      } else if (tabName === 'resourceInfo' && this.allowViewEditResource()) {
        this.fetchBaseInfo();
      }
    }
  })
});

/***/ }),

/***/ 2523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__ = __webpack_require__(1348);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__["a" /* default */]],
  props: {
    internUserId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      search: {
        id: null,
        intern_user_id: null
      },
      logColumns: [{ prop: 'id', label: '操作ID', width: '120' }, { prop: 'action', label: '操作', minWidth: '150' }, { prop: 'creator', label: '操作人', width: '150' }, { prop: 'created_at', label: '操作时间', width: '180' }],
      dataDiffDialogVisible: false,
      currentLogData: null,
      fieldLabels: {
        'id': '用户ID',
        'name': '账号',
        'realname': '姓名',
        'employment_type': '人员性质',
        'status': '状态',
        'phone': '手机号',
        'mail_address': '个人邮箱',
        'school': '目前所在院校',
        'major': '专业',
        'education_level': '学历',
        'grade_level': '当前学年段',
        'student_card_photos': '学生证照片',
        'contract_start_date': '合同开始时间',
        'contract_end_date': '合同结束时间',
        'remark': '备注',
        'assigned_customers': '客户资源',
        'ui_roles': 'UI权限角色',
        'api_roles': 'API权限角色',
        'created_at': '创建时间',
        'id_number': '身份证号码',
        'id_card_front_photo': '身份证正面照片',
        'id_card_back_photo': '身份证反面照片',
        'bank_name': '银行名称',
        'bank_branch_name': '支行名称',
        'bank_card_number': '银行卡号',
        'bank_card_photo': '银行卡照片'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Vuex.mapState({})),
  created: function created() {},
  mounted: function mounted() {},

  watch: {
    internUserId: function internUserId(newVal) {
      if (newVal) {
        this.search.intern_user_id = newVal;
        this.loadTableData({});
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), request.map([]), {
    getTableData: function getTableData(params) {
      return request.common('queryInternLogTableApi', params);
    },
    showDataDiff: function showDataDiff(logItem) {
      if (!this.hasSuperPermission()) {
        this.$message.error('您并非超级管理员,无法查看数据变化');
        this.dataDiffDialogVisible = false;
        return;
      }
      this.currentLogData = logItem.data;
      this.dataDiffDialogVisible = true;
    },
    hasSuperPermission: function hasSuperPermission() {
      return filter.superPermission();
    },

    /**
     * 格式化值用于显示（数组返回数组，其他返回字符串）
     */
    formatValueForDisplay: function formatValueForDisplay(value, field) {
      if (value === null || value === undefined) {
        return '-';
      }
      if (Array.isArray(value)) {
        return value;
      }
      if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(value)) === 'object') {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(value, null, 2);
      }
      if (['id_card_front_photo', 'id_card_back_photo'].includes(field) && !Array.isArray(value)) {
        return [value];
      }
      return String(value);
    },

    /**
     * 复制文本到剪贴板
     * @param {String} text - 要复制的文本
     */
    copyToClipboard: function copyToClipboard(text) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.$message.success('已复制到剪贴板');
    },

    /**
     * 获取变化数据用于表格显示
     * @returns {Array} 格式化后的变化数据数组
     */
    getDiffData: function getDiffData() {
      var _this = this;

      if (!this.currentLogData || !this.currentLogData.new) {
        return [];
      }
      // 以下字段的变化不显示到页面上
      var excludedFields = ['participant_customers', 'participant_projects', 'account_id', 'updated_at', 'total_work_days', 'intern_user_id'];
      var diffData = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.currentLogData.new).forEach(function (key) {
        if (!excludedFields.includes(key)) {
          diffData.push({
            field: key,
            fieldLabel: _.get(_this.fieldLabels, key, key),
            oldValue: _this.formatValueForDisplay(_this.currentLogData.old[key], key),
            newValue: _this.formatValueForDisplay(_this.currentLogData.new[key], key)
          });
        }
      });
      return diffData;
    }
  })
});

/***/ }),

/***/ 3211:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3212);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("434780f3", content, true, {});

/***/ }),

/***/ 3212:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".detail-label[data-v-7094c421]{color:#606266;font-weight:500}.detail-value[data-v-7094c421]{color:#303133}.image-list[data-v-7094c421],.photo-view-container[data-v-7094c421]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:12px}.photo-item[data-v-7094c421]{position:relative;display:inline-block}.photo-view-image[data-v-7094c421]{width:100px;height:100px;-o-object-fit:cover;object-fit:cover;border:1px solid #dcdfe6;border-radius:4px;cursor:-webkit-zoom-in;cursor:zoom-in;-webkit-transition:border-color .3s,-webkit-transform .2s;transition:border-color .3s,-webkit-transform .2s;transition:border-color .3s,transform .2s;transition:border-color .3s,transform .2s,-webkit-transform .2s}.photo-view-image[data-v-7094c421]:hover{border-color:#409eff;-webkit-transform:scale(1.05);transform:scale(1.05)}.id-card-wrapper[data-v-7094c421]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-right:16px}.id-card-label[data-v-7094c421]{font-size:12px;color:#909399;margin-bottom:4px}.id-card-image[data-v-7094c421]{width:160px;height:100px}.project-tag[data-v-7094c421]{margin-right:8px;margin-bottom:4px}.footer-actions[data-v-7094c421]{margin-top:-5px;padding-top:20px;border-top:1px solid #e4e7ed}", "", {"version":3,"sources":["/workspace/src/views/audit-intern/pages/AuditInternDetail.vue"],"names":[],"mappings":"AACA,+BAA+B,cAAc,eAAe,CAC3D,AACD,+BAA+B,aAAa,CAC3C,AAGD,oEAAuC,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,QAAQ,CACrI,AACD,6BAA6B,kBAAkB,oBAAoB,CAClE,AACD,mCAAmC,YAAY,aAAa,oBAAoB,iBAAiB,yBAAyB,kBAAkB,uBAAuB,eAAe,0DAA6D,kDAAqD,0CAA6C,+DAAoE,CACpZ,AACD,yCAAyC,qBAAqB,8BAA8B,qBAAqB,CAChH,AACD,kCAAkC,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,yBAAyB,sBAAsB,mBAAmB,iBAAiB,CAClR,AACD,gCAAgC,eAAe,cAAc,iBAAiB,CAC7E,AACD,gCAAgC,YAAY,YAAY,CACvD,AACD,8BAA8B,iBAAiB,iBAAiB,CAC/D,AACD,iCAAiC,gBAAgB,iBAAiB,4BAA4B,CAC7F","file":"AuditInternDetail.vue","sourcesContent":["\n.detail-label[data-v-7094c421]{color:#606266;font-weight:500\n}\n.detail-value[data-v-7094c421]{color:#303133\n}\n.image-list[data-v-7094c421]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:12px\n}\n.photo-view-container[data-v-7094c421]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:12px\n}\n.photo-item[data-v-7094c421]{position:relative;display:inline-block\n}\n.photo-view-image[data-v-7094c421]{width:100px;height:100px;-o-object-fit:cover;object-fit:cover;border:1px solid #dcdfe6;border-radius:4px;cursor:-webkit-zoom-in;cursor:zoom-in;-webkit-transition:border-color 0.3s, -webkit-transform 0.2s;transition:border-color 0.3s, -webkit-transform 0.2s;transition:border-color 0.3s, transform 0.2s;transition:border-color 0.3s, transform 0.2s, -webkit-transform 0.2s\n}\n.photo-view-image[data-v-7094c421]:hover{border-color:#409eff;-webkit-transform:scale(1.05);transform:scale(1.05)\n}\n.id-card-wrapper[data-v-7094c421]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-right:16px\n}\n.id-card-label[data-v-7094c421]{font-size:12px;color:#909399;margin-bottom:4px\n}\n.id-card-image[data-v-7094c421]{width:160px;height:100px\n}\n.project-tag[data-v-7094c421]{margin-right:8px;margin-bottom:4px\n}\n.footer-actions[data-v-7094c421]{margin-top:-5px;padding-top:20px;border-top:1px solid #e4e7ed\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternLogTable_vue__ = __webpack_require__(2523);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffdcc786_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternLogTable_vue__ = __webpack_require__(3220);
function injectStyle (ssrContext) {
  __webpack_require__(3214)
  __webpack_require__(3216)
  this["$style"] = __webpack_require__(3218)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ffdcc786"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternLogTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffdcc786_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternLogTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3214:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3215);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("9b982712", content, true, {});

/***/ }),

/***/ 3215:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".data-diff-container{max-height:70vh;overflow-y:auto}.field-name{font-weight:700;font-size:14px;color:#303133}.diff-value-cell{padding:4px 0!important}.log-tag-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:4px;padding:2px;-webkit-box-sizing:border-box;box-sizing:border-box;text-align:left;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.value-tag{max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;cursor:pointer;-webkit-transition:all .3s;transition:all .3s;margin:0}.value-tag:hover{-webkit-transform:translateY(-1px);transform:translateY(-1px);-webkit-box-shadow:0 2px 8px rgba(0,0,0,.15);box-shadow:0 2px 8px rgba(0,0,0,.15)}.value-content{font-size:12px;line-height:1.5;padding:6px 4px;border-radius:3px;border:1px solid #dcdfe6;word-break:break-all;white-space:normal;font-family:Courier New,monospace;max-height:120px;min-height:30px;overflow-y:auto;text-align:left}.value-content.old-value{background-color:#fef0f0;border-color:#fbc4c4}.value-content.new-value{background-color:#f0f9ff;border-color:#b3d8ff}.no-changes{text-align:right;padding:40px;color:#909399;font-size:14px}.el-form-item__tips{font-size:12px;color:#909399;line-height:1.5;margin-top:5px}", "", {"version":3,"sources":["/workspace/src/views/audit-intern/components/InternLogTable.vue"],"names":[],"mappings":"AACA,qBAAqB,gBAAgB,eAAe,CACnD,AACD,YAAY,gBAAiB,eAAe,aAAa,CACxD,AACD,iBAAiB,uBAAwB,CACxC,AACD,mBAAmB,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,QAAQ,YAAY,8BAA8B,sBAAsB,gBAAgB,wBAAwB,qBAAqB,sBAAsB,CAC3U,AACD,WAAW,eAAe,gBAAgB,uBAAuB,mBAAmB,eAAe,2BAA4B,mBAAoB,QAAQ,CAC1J,AACD,iBAAiB,mCAAmC,2BAA2B,6CAA8C,oCAAqC,CACjK,AACD,eAAe,eAAe,gBAAgB,gBAAgB,kBAAkB,yBAAyB,qBAAqB,mBAAmB,kCAAqC,iBAAiB,gBAAgB,gBAAgB,eAAe,CACrP,AACD,yBAAyB,yBAAyB,oBAAoB,CACrE,AACD,yBAAyB,yBAAyB,oBAAoB,CACrE,AACD,YAAY,iBAAiB,aAAa,cAAc,cAAc,CACrE,AACD,oBAAoB,eAAe,cAAc,gBAAgB,cAAc,CAC9E","file":"InternLogTable.vue","sourcesContent":["\n.data-diff-container{max-height:70vh;overflow-y:auto\n}\n.field-name{font-weight:bold;font-size:14px;color:#303133\n}\n.diff-value-cell{padding:4px 0 !important\n}\n.log-tag-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:4px;padding:2px;-webkit-box-sizing:border-box;box-sizing:border-box;text-align:left;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start\n}\n.value-tag{max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;cursor:pointer;-webkit-transition:all 0.3s;transition:all 0.3s;margin:0\n}\n.value-tag:hover{-webkit-transform:translateY(-1px);transform:translateY(-1px);-webkit-box-shadow:0 2px 8px rgba(0,0,0,0.15);box-shadow:0 2px 8px rgba(0,0,0,0.15)\n}\n.value-content{font-size:12px;line-height:1.5;padding:6px 4px;border-radius:3px;border:1px solid #dcdfe6;word-break:break-all;white-space:normal;font-family:'Courier New', monospace;max-height:120px;min-height:30px;overflow-y:auto;text-align:left\n}\n.value-content.old-value{background-color:#fef0f0;border-color:#fbc4c4\n}\n.value-content.new-value{background-color:#f0f9ff;border-color:#b3d8ff\n}\n.no-changes{text-align:right;padding:40px;color:#909399;font-size:14px\n}\n.el-form-item__tips{font-size:12px;color:#909399;line-height:1.5;margin-top:5px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3216:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3217);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5f61fd95", content, true, {});

/***/ }),

/***/ 3217:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"InternLogTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3218:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3219);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("56f6e7ed", content, true, {});

/***/ }),

/***/ 3219:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"InternLogTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-panel',[_c('template',{slot:"header"},[_vm._v("操作日志")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_vm._l((_vm.logColumns),function(attr){return [_c('el-table-column',_vm._b({},'el-table-column',attr,false))]}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[(_vm.hasSuperPermission())?_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.showDataDiff(scope.row)}}},[_vm._v("查看数据变化\n          ")]):_vm._e()],1)]}}])})],2),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"数据变化","visible":_vm.dataDiffDialogVisible,"width":"900px","top":"5vh"},on:{"update:visible":function($event){_vm.dataDiffDialogVisible=$event}}},[(_vm.currentLogData)?_c('div',{staticClass:"data-diff-container"},[_c('el-table',{attrs:{"data":_vm.getDiffData(),"border":"","show-header":true}},[_c('el-table-column',{attrs:{"prop":"field","label":"字段","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"field-name"},[_vm._v(_vm._s(scope.row.fieldLabel))])]}}],null,false,1754306252)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"oldValue","label":"旧值","class-name":"diff-value-cell"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(Array.isArray(scope.row.oldValue) && scope.row.oldValue.length > 0)?_c('div',{staticClass:"log-tag-container"},_vm._l((scope.row.oldValue),function(item,index){return _c('el-tag',{key:index,staticClass:"value-tag",attrs:{"size":"mini","title":item},on:{"click":function($event){return _vm.copyToClipboard(item)}}},[_vm._v("\n                "+_vm._s(index + 1)+". "+_vm._s(item)+"\n              ")])}),1):_c('div',{staticClass:"value-content old-value",attrs:{"title":scope.row.oldValue}},[_vm._v("\n              "+_vm._s(scope.row.oldValue)+"\n            ")])]}}],null,false,3320705109)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"newValue","label":"新值","class-name":"diff-value-cell"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(Array.isArray(scope.row.newValue) && scope.row.newValue.length > 0)?_c('div',{staticClass:"log-tag-container"},_vm._l((scope.row.newValue),function(item,index){return _c('el-tag',{key:index,staticClass:"value-tag",attrs:{"size":"mini","type":"success","title":item},on:{"click":function($event){return _vm.copyToClipboard(item)}}},[_vm._v("\n                "+_vm._s(index + 1)+". "+_vm._s(item)+"\n              ")])}),1):_c('div',{staticClass:"value-content new-value",attrs:{"title":scope.row.newValue}},[_vm._v("\n              "+_vm._s(scope.row.newValue)+"\n            ")])]}}],null,false,453718968)})],1)],1):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/audit-intern/table"}},[_vm._v("实习生管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":_vm.handleTabClick},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[(_vm.allowViewEditBase())?_c('el-tab-pane',{attrs:{"label":"基础资料","name":"baseInfo"}},[_c('layout-panel',{attrs:{"show-header":false}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.baseInfoTableData,"border":"","show-header":false}},[_c('el-table-column',{attrs:{"prop":"label","label":"字段","width":"150","align":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"detail-label"},[_vm._v(_vm._s(scope.row.label))])]}}],null,false,1759181692)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"值","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.type === 'text')?_c('span',{staticClass:"detail-value"},[_vm._v(_vm._s(scope.row.value))]):(scope.row.type === 'map')?_c('span',{staticClass:"detail-value"},[_vm._v(_vm._s(scope.row.value))]):(scope.row.type === 'images')?_c('div',{staticClass:"image-list"},[(scope.row.value && scope.row.value.length > 0)?_c('div',{staticClass:"photo-view-container",attrs:{"id":"baseInfoPhotoContainer"}},_vm._l((scope.row.value),function(url,index){return _c('div',{key:index,staticClass:"photo-item"},[_c('img',{staticClass:"photo-view-image",attrs:{"src":url},on:{"click":function($event){return _vm.onViewPhotos('baseInfo', index)}}})])}),0):_vm._e()]):(scope.row.type === 'tags')?_c('div',_vm._l((scope.row.value),function(item,index){return _c('el-tag',{key:index,staticClass:"project-tag",attrs:{"size":"small"}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])}),1):(scope.row.type === 'dateRange')?_c('span',[_vm._v(_vm._s(scope.row.value))]):_vm._e()]}}],null,false,3088150518)})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.allowViewEditPrivate())?_c('el-tab-pane',{attrs:{"label":"隐私信息","name":"privateInfo"}},[_c('layout-panel',{attrs:{"show-header":false}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.privateInfoTableData,"border":"","show-header":false}},[_c('el-table-column',{attrs:{"prop":"label","label":"字段","width":"150","align":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"detail-label"},[_vm._v(_vm._s(scope.row.label))])]}}],null,false,1759181692)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"值","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.type === 'text')?_c('span',{staticClass:"detail-value"},[_vm._v(_vm._s(scope.row.value))]):(scope.row.type === 'images')?_c('div',{staticClass:"image-list"},[(scope.row.value && scope.row.value.length > 0)?_c('div',{staticClass:"photo-view-container",attrs:{"id":"privateInfoPhotoContainer"}},_vm._l((scope.row.value),function(url,index){return _c('div',{key:index,staticClass:"photo-item"},[_c('img',{staticClass:"photo-view-image",attrs:{"src":url},on:{"click":function($event){return _vm.onViewPhotos('privateInfo', index)}}})])}),0):_vm._e()]):(scope.row.type === 'idCardImages')?_c('div',{staticClass:"image-list"},[(scope.row.value && scope.row.value.length > 0)?_c('div',{staticClass:"photo-view-container",attrs:{"id":"idCardPhotosContainer"}},_vm._l((scope.row.value),function(url,index){return _c('div',{key:index,staticClass:"photo-item"},[_c('img',{staticClass:"photo-view-image id-card-image",attrs:{"src":url},on:{"click":function($event){return _vm.onViewPhotos('idCardPhotos', index)}}})])}),0):_vm._e()]):_vm._e()]}}],null,false,2290814224)})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.allowViewEditResource())?_c('el-tab-pane',{attrs:{"label":"资源控制","name":"resourceInfo"}},[_c('layout-panel',{attrs:{"show-header":false}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.resourceInfoTableData,"border":"","show-header":false}},[_c('el-table-column',{attrs:{"prop":"label","label":"字段","width":"150","align":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"detail-label"},[_vm._v(_vm._s(scope.row.label))])]}}],null,false,1759181692)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"值","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.type === 'text')?_c('span',{staticClass:"detail-value"},[_vm._v(_vm._s(scope.row.value))]):(scope.row.type === 'tags')?_c('div',_vm._l((scope.row.value),function(item,index){return _c('el-tag',{key:index,staticClass:"project-tag",attrs:{"size":"small"}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])}),1):_vm._e()]}}],null,false,3015179170)})],1)],1)],1):_vm._e(),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"操作日志","name":"logInfo"}},[_c('InternLogTable',{attrs:{"internUserId":Number(_vm.id)}})],1)],1),_vm._v(" "),_c('div',{staticClass:"footer-actions"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/audit-intern-detail.326659f47996e8e75243.js